import { useEffect } from "react";

const SITE = (process.env.REACT_APP_SITE_URL || "https://www.bellafilmrj.com").replace(/\/$/, "");

const PROD_HOSTS = ["www.bellafilmrj.com", "bellafilmrj.com"];

function upsert(selector, tagName, attrs) {
  const all = document.head.querySelectorAll(selector);
  all.forEach((el, i) => { if (i > 0) el.remove(); });
  let el = all[0];
  if (!el) {
    el = document.createElement(tagName);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

export function SEO({ title, description, path = "/", jsonLd = [], image, noCanonical = false, robots }) {
  const canonical = `${SITE}${path}`;
  const ogImage = image || `${SITE}/images/hero-residencial.webp`;
  const ldJson = JSON.stringify(jsonLd);

  useEffect(() => {
    const isProd = PROD_HOSTS.includes(window.location.hostname);
    const robotsContent = robots || (isProd ? "index, follow" : "noindex, nofollow");
    document.title = title;
    document.head.querySelectorAll("title").forEach((el, i) => { if (i > 0) el.remove(); });
    upsert('meta[name="description"]', "meta", { name: "description", content: description });
    upsert('meta[name="robots"]', "meta", { name: "robots", content: robotsContent });
    if (noCanonical) {
      document.head.querySelectorAll('link[rel="canonical"]').forEach((el) => el.remove());
    } else {
      upsert('link[rel="canonical"]', "link", { rel: "canonical", href: canonical });
    }
    upsert('meta[property="og:title"]', "meta", { property: "og:title", content: title });
    upsert('meta[property="og:description"]', "meta", { property: "og:description", content: description });
    upsert('meta[property="og:url"]', "meta", { property: "og:url", content: canonical });
    upsert('meta[property="og:image"]', "meta", { property: "og:image", content: ogImage });
    upsert('meta[name="twitter:card"]', "meta", { name: "twitter:card", content: "summary_large_image" });
    document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => el.remove());
    JSON.parse(ldJson).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, canonical, ogImage, noCanonical, robots, ldJson]);

  return null;
}

export const LOCAL_BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Bella Film RJ",
  description: "Instalação profissional de insulfilm residencial, comercial e automotivo no Rio de Janeiro desde 2010.",
  telephone: "+55-21-2018-4446",
  email: "bellafilmrj@gmail.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Rua do Matoso",
    addressLocality: "Rio de Janeiro",
    addressRegion: "RJ",
    addressCountry: "BR",
    neighborhood: "Tijuca",
  },
  areaServed: { "@type": "City", name: "Rio de Janeiro" },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "09:00",
    closes: "17:00",
  },
  sameAs: [
    "https://www.instagram.com/bellafilmrj/",
    "https://www.facebook.com/bellafilmrj/",
    "https://www.tiktok.com/@bellafilmrj",
  ],
  url: SITE,
};

export const WEBSITE_LD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Bella Film RJ",
  url: SITE,
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE}${item.path}`,
  })),
});
